// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tags[data-v-085452db]{display:flex;flex-wrap:wrap;gap:var(--size-2);list-style:none;margin:0;padding:0}.tag[data-v-085452db]{background:var(--color-forest-3);border-radius:var(--border-radius-2);color:var(--color-white-frost-1);padding:var(--size-1) var(--size-2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
